import { AuthenticationSvc } from './../services/AuthenticationSvc';
import { listenPostToken } from './../helpers/tokenMessage';
import directives from './module';
import { OAuthCallbackSvc } from '../services/OAuthCallbackSvc';
import { LocalStorageSvc } from '../services/LocalStorageSvc';
import { Utils } from '../underscore-extensions';
import { AnalyticSvc } from '../services/AnalyticSvc';

directives.component('oauthSignInButtons', {
    controller(
        this: any,
        $timeout: ng.ITimeoutService,
        $state: ng.ui.IStateService,
        analyticSvc: AnalyticSvc,
        AuthenticationSvc: AuthenticationSvc,
        OAuthCallbackSvc: OAuthCallbackSvc,
        LocalStorageSvc: LocalStorageSvc
    ) {
        const originProduct = Utils.getProduct().toLowerCase();

        const makeCallback = (service: string) => {
            const s =
                options.isLocal || originProduct === 'wave'
                    ? location.origin
                    : location.origin.replace(/(https?:\/\/)(www.)?/, '$1www.');
            return `${s}/callback/${service}`;
        };

        const buildOAuthUrl = (endpoint: string, apiKey: string, callback: string) =>
            `${endpoint}?response_type=token&client_id=${apiKey}&redirect_uri=${callback}`;

        const google = (() => {
            const apiKey = options.social.googleApiKey;
            const endpoint = 'https://accounts.google.com/o/oauth2/auth';
            //https://developers.google.com/+/web/api/rest/oauth
            return buildOAuthUrl(endpoint, apiKey, makeCallback('google')) + `&scope=profile email`;
        })();

        const facebook = (() => {
            const apiKey = options.social.facebookApiKey;
            const endpoint = 'https://www.facebook.com/dialog/oauth';
            return buildOAuthUrl(endpoint, apiKey, makeCallback('facebook')) + `&scope=email&display=popup`;
        })();

        const twitter = `${options.apiDomain}/authenticate/twitter?redirect_uri=${location.origin}/callback/twitter/`;

        const dribbble = (() => {
            const apiKey = options.social.dribbbleApiKey;
            const callback = options.isLocal
                ? `${location.origin}/callback/dribbble`
                : options.social.oauthCallback.replace('WEBFB', 'WEBDR');
            return `https://dribbble.com/oauth/authorize?client_id=${apiKey}&redirect_uri=${callback}`;
        })();

        this.open = (link: string, provider: anm.SignUpProvider) =>
            $timeout(() => {
                listenPostToken(({ token, provider: oauthService }) =>
                    AuthenticationSvc.loginOAuth(
                        token,
                        oauthService.toUpperCase(),
                        Utils.getProduct().toLowerCase() as AnimatronProduct
                    )
                );

                analyticSvc.signUpSocialSubmit(provider);
                window.open(link, 'Auth', 'width=640, height=480,resizable,scrollbars,status');
            });

        this.providers = { facebook, google };

        window.addEventListener(
            'storage',
            function listener(e: StorageEvent) {
                if (LocalStorageSvc.get('auth') || (e.key === 'auth' && e.newValue)) {
                    window.removeEventListener('storage', listener);
                    LocalStorageSvc.remove('auth');
                    const value = JSON.parse(e.newValue);
                    $timeout(() => OAuthCallbackSvc.doLogin(value.params, value.stateParams));
                }
            },
            false
        );
    },
    template: `<div class="sign-in-buttons-wrapper">
            <a ng-click="$ctrl.open(link, provider)" ng-repeat="(provider, link) in ::$ctrl.providers"
               target="Auth" class="sign-in {{provider}}-signin"></a>
               </div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/oauthSignInButtons.ts